import { securityApi } from "@/api/security.api.ts";
import useErrorHandle from "@/hooks/use-error-handle.hook.tsx";
import { ApiErrorException } from "@/types/api.types.ts";
import { ApiSecuritySettings } from "@/types/security.types.ts";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Control, FieldValues } from "react-hook-form";

export const securityKeys = createQueryKeys("security", {
  settings: {
    queryKey: null,
    queryFn: async () => {
      const result = await securityApi.getSecuritySettings();

      if (result.error) throw new ApiErrorException(result.error);

      return result.data;
    },
  },
});

export const useSecuritySettings = () => {
  return useQuery({
    ...securityKeys.settings,
  });
};

export const useSecuritySettingsUpdate = <TFieldValues extends FieldValues>(
  control: Control<TFieldValues>
) => {
  const queryClient = useQueryClient();
  const { onError } = useErrorHandle();

  return useMutation({
    mutationFn: async (payload: ApiSecuritySettings) => {
      const result = await securityApi.updateSecuritySettings(payload);

      if (result.error) throw new ApiErrorException(result.error);

      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: securityKeys.settings.queryKey,
      });
    },
    onError: (error: Error) => {
      onError(error, control);
    },
  });
};
